import { useNavigate } from 'react-router-dom';

import { PlayCircleOutlined } from '@ant-design/icons';
import { Container, Content, Footer, Header } from './styles';
import { NavigateToTournamentsPage } from '../../../../utils/NavigateToTournamentsPage';

interface CardProps {
  id: number;
  level: string;
  img: string;
  name: string;
  edition: string;
}

export const Card: React.FC<CardProps> = ({
  id,
  level,
  img,
  name,
  edition,
}: CardProps) => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header level={level}>
        <p>{level}</p>
      </Header>

      <Content onClick={() => NavigateToTournamentsPage(navigate, id)}>
        <span>
          <img src={img} alt={name} />
        </span>

        <div>
          <span>
            <h1>{name}</h1>
            <h2>{edition}</h2>
          </span>
        </div>
      </Content>

      <Footer>
        <button type="button">
          <PlayCircleOutlined />
        </button>
      </Footer>
    </Container>
  );
};
